import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useAuth } from "@/features/auth/AuthContext"
import { getAnalyticsAreaForPath } from "@/lib/analytics/routeArea"
import {
  setProductAnalyticsContext,
  trackProductEvent,
} from "@/lib/analytics/productAnalytics"

export const ProductAnalyticsTracker = () => {
  const { pathname } = useLocation()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    setProductAnalyticsContext(
      getAnalyticsAreaForPath(pathname),
      isAuthenticated ? "authenticated" : "anonymous",
    )
  }, [pathname, isAuthenticated])

  useEffect(() => {
    trackProductEvent("page_viewed")
  }, [pathname])

  return null
}
